<template>
  <v-container pa-0 fill-height>
    <v-btn v-if="id != ''" text small @click="onClick">
      <v-icon left small>mdi-account-tie</v-icon>
      {{ label }}
    </v-btn>
    <span v-else>
      <v-icon left small>mdi-account-tie</v-icon>
      {{ label }}
    </span>
  </v-container>
</template>

<script>
export default {
  name: "agent-label",
  props: {
    value: {
      type: String,
      defaule: () => "Agent Name",
    },
    agentId: {
      type: String,
      default: () => "",
    },
  },

  computed: {
    label() {
      return this.params ? this.params.data.agentName : this.value;
    },
    id() {
      return this.params
        ? this.params.data.agent
          ? this.params.data.agent.id
          : this.params.data.agentId
        : this.agentId;
    },
  },

  methods: {
    onClick() {
      this.$router.push(`/agent/${this.id}/edit`);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/labels/AgentLabel.vue